import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { ARATDefinition, BBSDefinition, BBTDefinition, FGADefinition, NHPTDefinition } from '../assessment-definitions';
import { AssessmentDefinition } from '../models/assessment-definition.model';

@Injectable({
  providedIn: 'root',
})
export class AssessmentDefinitionService {
  private assessmentsCache = new Map<string, AssessmentDefinition>();
  private assessmentsSubject = new BehaviorSubject<AssessmentDefinition[]>([]);

  assessments$ = this.assessmentsSubject.asObservable();

  constructor() {
    this.loadAllAssessments();
  }

  /**
   * Lädt alle verfügbaren Assessment-Definitionen
   */
  loadAllAssessments(): void {
    // Importierte Assessment-Definitionen verwenden statt lokaler Methoden
    const assessments = [BBSDefinition, BBTDefinition, ARATDefinition, FGADefinition, NHPTDefinition];

    assessments.forEach(assessment => this.assessmentsCache.set(assessment.id, assessment));
    this.assessmentsSubject.next(assessments);
  }

  /**
   * Lädt eine Assessment-Definition aus einer JSON-Datei
   */
  // loadAssessmentFromJson(path: string): Observable<AssessmentDefinition> {
  // return this.http.get<AssessmentDefinition>(path).pipe(
  //   tap(definition => {
  //     this.assessmentsCache.set(definition.id, definition);
  //     const currentAssessments = this.assessmentsSubject.value;
  //     this.assessmentsSubject.next([...currentAssessments, definition]);
  //   }),
  //   catchError(error => {
  //     console.error('Fehler beim Laden des Assessments:', error);
  //     return of(null as unknown as AssessmentDefinition);
  //   })
  // );
  // }

  /**
   * Holt eine Assessment-Definition anhand der ID
   */
  getAssessmentById(id: string): Observable<AssessmentDefinition | undefined> {
    if (this.assessmentsCache.has(id)) {
      return of(this.assessmentsCache.get(id));
    }

    // Wenn nicht im Cache, versuchen zu laden (in einer vollständigen Implementierung)
    return of(undefined);
  }
}
